import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Link } from 'react-router';
import { SignInForm } from '@/components/forms/signin';
import { IS_GOOGLE_SSO_ENABLED, IS_OIDC_SSO_ENABLED, OIDC_PROVIDER_LABEL } from '@/lib/auth-config';

export function SignIn() {
  useLocale();

  const BUN_PUBLIC_DISABLE_SIGNUP = process.env.BUN_PUBLIC_DISABLE_SIGNUP;
  return (
    <div className="relative z-10 flex h-full w-screen max-w-lg items-center justify-center px-4">
      <div className="w-full rounded-xl border border-border bg-background p-6">
        <h1 className="font-semibold text-2xl">{t('auth.signInToYourAccount')}</h1>
        <p className="mt-2 text-muted-foreground text-sm">
          {t('auth.welcomeBackWeAreLuckyToHaveYou')}{' '}
        </p>
        <hr className="-mx-6 my-4" />
        <SignInForm
          isGoogleSSOEnabled={IS_GOOGLE_SSO_ENABLED}
          isOIDCSSOEnabled={IS_OIDC_SSO_ENABLED}
          oidcProviderLabel={OIDC_PROVIDER_LABEL}
        />
        {BUN_PUBLIC_DISABLE_SIGNUP !== 'true' && (
          <p className="mt-6 text-center text-muted-foreground text-sm">
            {t('auth.donTHaveAnAccount')}{' '}
            <Link className="text-primary duration-200 hover:opacity-70" to="/auth/signup">
              {t('auth.signUp')}{' '}
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
